import {
  useDraftDeleteDocumentMutation,
  useDraftDeleteImageMutation,
  useDraftUploadDocumentMutation,
  useDraftUploadImageMutation
} from "@/src-refactor/modules/store/qrtk/services/property-draft/property-draft.qrtk";
import { HGenerateFileData, IFileData } from "@rf-l1/file/helpers/create-file-data";
import { useFormContext } from "react-hook-form";
import { CPropertyFormKeys } from "../util/schemas/property-schema/propertySchema";
import { useParams } from "react-router-dom";
import { onSendEventBlockerEnd, onSendEventBlockerStart } from "./useUploadingBlocker";

const useManagerDocumentsDraft = () => {
  const { setValue, getValues } = useFormContext();
  const { idDraft } = useParams();
  const draftId = Number(idDraft);
  const [uploadDocument] = useDraftUploadDocumentMutation();
  const [deleteDocument] = useDraftDeleteDocumentMutation();

  const uploadDocumentDraft = async (data: IFileData, type: string, key: string) => {
    return new Promise(async (resolve, reject) => {
      try {
        onSendEventBlockerStart();
        const res = await uploadDocument({
          params: {
            draft: draftId
          },
          body: {
            document: data.file as File,
            type: type
          }
        })
          .then(res => {
            const document = HGenerateFileData({
              file: res.data?.data.path ?? "",
              id: Number(res.data?.data.id) ?? 0,
              comment: ""
            });

            // const newArray = [...getValues(key)];
            // const pos = newArray.findIndex(item => item.id === data.id);
            // newArray.splice(pos, 1, document);

            setValue(key, [document]);
            resolve({
              url: document?.url ?? "",
              id: document?.id.toString() ?? ""
            });
          })
          .catch(err => {
            reject(err);
          })
          .finally(() => {
            onSendEventBlockerEnd();
          });
      } catch (e) {
        onSendEventBlockerEnd();
        reject(e);
      }
    });
  };

  const deleteDocumentDraft = (index: number, key: string) => {
    return new Promise<void>(async (resolve, reject) => {
      try {
        const fields = getValues(key) as IFileData[];
        const resourceId = fields?.[index]?.id;
        if (resourceId) {
          await deleteDocument({
            params: {
              draft: draftId,
              document: resourceId
            }
          }).unwrap();
        }
        setValue(
          key,
          fields.filter((_, i) => i !== index)
        );
        resolve(void 0);
      } catch (err) {
        reject(void 0);
      }
    });
  };

  return {
    uploadDocumentDraft,
    deleteDocumentDraft
  };
};

export default useManagerDocumentsDraft;
